var AbstractSettingsDelegate = require("./AbstractSettingsDelegate");
var GeneralAppConfigView = require("./GeneralAppConfigView");
var Utils = require("common/Utils");

function GeneralAppConfigSettingsDelegate() {
    AbstractSettingsDelegate.call(this);

    const self = this;
    const configView = new GeneralAppConfigView();

    /**
     * @override
     * @inheritDoc
     */
    this.getId = function() {
        return "GeneralAppConfigSettingsDelegate";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getLabel = function() {
        return $.t("common::general.title");
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getViews = function() {
        return [configView];
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getTopLevelViews = function() {
        return [configView];
    };

    /**
     * @override
     * @inheritDoc
     */
    this.setMenuEntry = function(entry) {
        entry.on("click", function() {
            self.showView(configView);
        });
    };
}

Utils.inherits(GeneralAppConfigSettingsDelegate, AbstractSettingsDelegate);

module.exports = GeneralAppConfigSettingsDelegate;


//////////////////
// WEBPACK FOOTER
// ./settings/GeneralAppConfigSettingsDelegate.js
// module id = 86
// module chunks = 0 3